export default __webpack_public_path__ + "static/media/1021.704fa5a1.png";